<script>
export default {
  name: 'GameCardPlaceholder',
};
</script>

<template lang="pug">
div.game-card-placeholder.bg-gray

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "styles/variables.css";

.game-card-placeholder {
  padding-bottom: 52%;

  animation-duration: 2s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: backgroundPlaceholderAnimation;
  animation-timing-function: linear;
  background: #f6f7f8;
  background: #eeeeee;
  background: linear-gradient(to right, rgba(255, 255, 255, 0.2) 0%, transparent 50%, rgba(255, 255, 255, 0.2) 100%);
  background-size: 800px 104px;
  border: solid 1px transparent;
}
@keyframes backgroundPlaceholderAnimation {
  0% {
    background-position: -400px 0;
    /* border-color: var(--green); */
  }
  50% {
    /* background-position: 0 0; */
    /* border-color: transparent; */
  }
  100% {
    background-position: 400px 0;
    /* border-color: var(--green); */
  }
}
</style>
